import { useHistory, useLocation } from 'react-router-dom';
import { useCallback, useMemo } from 'react';

export function useQueryStrings() {
  const history = useHistory();
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const update = useCallback(
    values => {
      Object.entries(values).forEach(([name, value]) => {
        if (!value) {
          return params.delete(name);
        }

        if (params.has(name)) {
          return params.set(name, value);
        }

        params.append(name, value);
      });
      history.push({ search: params.toString() });
    },
    [history, params]
  );

  return { params, update };
}
